import type { Node } from "@tiptap/pm/model";

/** Selection content, not editor coordinate serialization: retain explicit line breaks. */
export function manuscriptSelectionText(doc: Node, from: number, to: number): string {
  return doc.textBetween(from, to, "\n", node =>
    node.type.name === "hardBreak" || node.type.name === "hard_break"
      ? "\n"
      : node.type.spec.leafText?.(node) ?? "",
  );
}
